<div class="wrapper">
    <div class="sidebar" [attr.data-color]="isBetaEnvironment ? 'dark-blue-ipec' : 'azure'" data-image="">
        <app-sidebar></app-sidebar>
        <div class="sidebar-background" style="background-image: url(/assets/img/sidebar-0.jpg)"></div>
    </div>
    <app-user-menu></app-user-menu>

    <div class="main-panel">
        <navbar-cmp></navbar-cmp>
        <router-outlet></router-outlet>
        <!--<div *ngIf="isMap('maps')">
        <footer-cmp></footer-cmp>
    </div>-->
    </div>
</div> 